// extracted by mini-css-extract-plugin
module.exports = {"selectbox-icon":"Selectbox_selectbox-icon__3d7xi","reversed":"Selectbox_reversed__ByuGA","disabled":"Selectbox_disabled__C1AvV","decoration":"Selectbox_decoration__5trnm"};